import { TemplateId } from '@types';
import { PUBLIC_DOMAIN } from '@constants';

const isProd = process.env.DOMAIN_ENV === 'prod';

export const TEMPLATES_CONFIG: Record<
  TemplateId,
  { name: string; thumb: string; demo: string; desc: string; isFree?: boolean }
> = {
  [TemplateId.free]: {
    name: '经典免费版',
    thumb: `${PUBLIC_DOMAIN}/imgs/template2.900cbde08ee73ef61e0efa6f103f5ca9.png`,
    demo: isProd
      ? 'https://www.720yun.com/vr/66f3999cb1x'
      : 'https://test.720yun.com/vr/3323b636t92',
    desc: '该模板是经典系列的免费模板，通用性强，广泛适用于不同行业的720漫游基础性展示。',
    isFree: true,
  },
  [TemplateId.vip]: {
    name: '经典2.0',
    thumb: `${PUBLIC_DOMAIN}/imgs/2.0.f30b04f45f4f2c74c663f251e8d38743.png`,
    demo: isProd
      ? 'https://www.720yun.com/vr/93e3b6f3b1h'
      : 'https://test.720yun.com/vr/f8a367dct9d',
    desc: '该模板是720浸游工具2021全新2.0版本上线时推出的系统默认模板，在经典1.0模板基础上进行了UI重构和优化，具有较强普适性和通用性。',
    isFree: true,
  },
  [TemplateId.simple]: {
    name: '清爽简洁版',
    thumb: `${PUBLIC_DOMAIN}/imgs/template3.5f119e73b068428f3e5ce864c7f2fc31.png`,
    demo: isProd
      ? 'https://www.720yun.com/vr/188330beb1m'
      : 'https://test.720yun.com/vr/6933e87bt99',
    desc: '该模板主要为室内设计、家居家装、地产行业等内部空间漫游展示量身定制，界面清爽简洁。',
  },
  [TemplateId.realEstateA]: {
    name: '房产版A',
    thumb: `${PUBLIC_DOMAIN}/imgs/template4.315c96abeba86c6f93ced77bd7dd12f3.png`,
    demo: isProd
      ? 'https://www.720yun.com/vr/e68zbd2tr0t'
      : 'https://test.720yun.com/vr/798m663bcua',
    desc: '该模板是房地产行业VR漫游展示的定制模板，支持设置10个自定义菜单按钮，同时包含“免责声明”功能。',
  },
  [TemplateId.metaverseA]: {
    name: '元宇宙版A',
    thumb: `${PUBLIC_DOMAIN}/imgs/template6.77314a8ea11a179854de67f9739a7cf6.png`,
    demo: isProd
      ? 'https://www.720yun.com/vr/b0d2djbfmeg'
      : 'https://test.720yun.com/vr/cdbmdacycsg',
    desc: '该模板支持AI数字人讲解/真人视频讲解功能，让VR漫游具有更强的互动性和交互性，打造元宇宙时代的全新体验',
  },
  [TemplateId.realEstateB]: {
    name: '房产版B',
    thumb: `${PUBLIC_DOMAIN}/imgs/template7.a82cd1e1b12f206485c5549dbeeefd4b.png`,
    demo: isProd
      ? 'https://www.720yun.com/vr/9112eaO6wc6'
      : 'https://test.720yun.com/vr/8b2m6a9y4vn',
    desc: '该模板是房地产行业VR漫游展示的定制模板，支持AI数字人讲解/真人视频讲解功能',
  },
  [TemplateId.legacy]: {
    name: '经典1.0',
    thumb: `${PUBLIC_DOMAIN}/imgs/1.0.cbfc3282bb5b2130c782dc98d12eff2d.png`,
    demo: isProd
      ? 'https://www.720yun.com/vr/66f3999cb1x'
      : 'https://test.720yun.com/vr/3323b636t92',
    desc: '该模板是720云2014年第1个版本上线时推出的经典系列模板，深受广大老用户青睐，具有较高通用性，广泛适用于不同行业的VR漫游展示',
    isFree: true,
  },
  [TemplateId.project]: {
    name: '工程记录版',
    thumb: `${PUBLIC_DOMAIN}/imgs/project.5555f94925c7f8504215661a79821260.png`,
    demo: isProd
      ? 'https://www.720yun.com/vr/89ejzpywtk1'
      : 'https://test.720yun.com/vr/055m8ef1eOn',
    desc: '该模板针对室内装修、建筑工程BIM等行业，对同一施工点可以快速切换查看不同时间段的工程情况，并通过场景对比功能进行分屏对比观看',
  },
};
